import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";
import { FaDownload, FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "./mentor.css";

// const API_URL = "http://localhost:8000/mentor.php";

const API_URL = "https://crm.fazoacademy.in/php/mentor.php";

// const API_URL_Student = "http://localhost:8000/student_mentor.php";

const API_URL_Student = "https://crm.fazoacademy.in/php/student_mentor.php";



function Mentor({ onLogout }) {
  const [courses, setCourses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);

  // edit 
  const [showEditModal, setShowEditModal] = useState()

  const [newCourse, setNewCourse] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [coursename, setCoursename] = useState("");
  const [mentorid, setMentorid] = useState("");
  const [image, setImage] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [editCourse, setEditCourse] = useState({
    name: "",
    phone: "",
    email: "",
    course: "",

  });


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [student, setStudent] = useState([]);

  useEffect(() => {
    fetchCourses();
    // fetchStudent();
  }, []);

  useEffect(() => {
    setMentorid(`MEN_${phone}`);
  }, [phone]);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(API_URL);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setCourses(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    }
  };
  // console.log(courses)

  // const fetchStudent = async () => {
  //   try {
  //     const response = await axios.get(API_URL_Student);
  //     const jsonString = response.data.substring(response.data.indexOf("["));
  //     const parsedData = JSON.parse(jsonString);
  //     setStudent(Array.isArray(parsedData) ? parsedData : []);
  //   } catch (error) {
  //     console.error("Error fetching courses:", error);
  //     setStudent([]);

  //   }
  // };
  // console.log(student);

  const handleAddCourse = async () => {
    if (!newCourse.trim()
      || !email.trim()
      || !phone.trim()
      || !coursename.trim()
      || !pdf
    ) {
      Swal.fire({
        icon: "warning",
        title: "Field Empty",
        text: "Please fill all required fields!",
      });
      return;
    }
    if (courses.some(enquiry => enquiry.phone === phone)) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Phone",
        text: "This phone number is already registered!",
      });
      return;
    }
    try {
      const formData = new FormData();
      formData.append("name", newCourse.trim());
      formData.append("email", email.trim());
      formData.append("phone", phone.trim());
      formData.append("course", coursename.trim());
      formData.append("mentor_id", mentorid.trim());
      if (image) formData.append("image", image);
      if (pdf) formData.append("pdf", pdf);

      await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchCourses();
      setShowAddModal(false);
      setNewCourse("");
      setEmail("");
      setPhone("");
      setCoursename("");
      setMentorid("");
      setImage(null);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Mentor added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Add error:", error);
      Swal.fire({ icon: "error", title: "Failed!", text: "Could not add mentor." });
    }
  };

  //edit 

  const handleEditCourse = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (
      !editCourse.name.trim() ||
      !editCourse.email.trim() ||
      !editCourse.phone.trim() ||
      !editCourse.course.trim()
    ) {
      Swal.fire({
        icon: "warning",
        title: "Field Empty",
        text: "Please fill all required fields!",
      });
      return;
    }

    if (!emailRegex.test(editCourse.email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address!",
      });
      return;
    }

    if (!phoneRegex.test(editCourse.phone)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: "Phone number must be 10 digits only!",
      });
      return;
    }

    const formData = new FormData();
    formData.append("action", "update");
    formData.append("id", editCourse.id);
    formData.append("name", editCourse.name);
    formData.append("email", editCourse.email);
    formData.append("phone", editCourse.phone);
    formData.append("course", editCourse.course);


    if (editCourse.image instanceof File) {
      formData.append("image", editCourse.image);
    }

    try {
      await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      fetchCourses();
      setShowEditModal(false);
      Swal.fire({
        icon: "success",
        title: "Mentor updated successfully",
      });
    } catch (err) {
      console.error("Error updating mentor:", err);
      Swal.fire({
        icon: "error",
        title: "Update failed",
      });
    }
  };

  const handleDeleteCourse = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}?id=${id}`);
          fetchCourses();
          Swal.fire("Deleted!", "Mentor deleted successfully.", "success");
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error", "Failed to delete mentor.", "error");
        }
      }
    });
  };
  const [studentList, setStudentList] = useState([]);


  const handleViewDetail = async (mentor) => {
    setSelectedMentor(mentor);
    setShowViewModal(true);

    try {
      const response = await axios.post(
        API_URL_Student,
        { mentorname: mentor.name },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Raw Response:", JSON.stringify(response.data, null, 2));

      if (response.data.status === "success") {
        const students = response.data.students || [];
        setStudentList(students);
        console.log("Student Data:", students);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudentList([]);
    }
    console.log(studentList)
  };

  // const handleViewDetail = async (mentor) => {
  //   setSelectedMentor(mentor);
  //   setShowViewModal(true);

  //   try {
  //     const response = await axios.post(
  //       API_URL_Student,
  //       { mentorname: mentor.name },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Raw Response:", response);

  //     const rawData = response.data;

  //     // Extract JSON-looking part (starts with { and ends with })
  //     const jsonMatch = rawData.match(/{.*}/s);
  //     if (jsonMatch) {
  //       const cleanJson = JSON.parse(jsonMatch[0]);

  //       if (cleanJson.status === "success") {
  //         console.log("Student Data:", cleanJson.students);
  //         // Do something with cleanJson.students
  //       } else {
  //         alert(cleanJson.message || "An error occurred.");
  //       }
  //     } else {
  //       alert("Failed to parse JSON from the response.");
  //     }

  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Failed to fetch student data.");
  //   }
  // };


  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };

  const handleDownloadpdf = (pdfPath) => {
    if (!pdfPath) {
      alert("No PDF file found for this mentor.");
      return;
    }

    window.open(`https://crm.fazoacademy.com/${pdfPath}`, "_blank");
    // window.open('http://localhost:8000/${pdfPath}', "_blank");

  };





  const filteredCourses = courses.filter((course) =>
    course.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.course.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="course-container">
      <div className="navigation">
        <a href="#">Mentor</a> / <a href="#" onClick={onLogout}>Logout</a>
      </div>

      <div className="add-course">
        <button onClick={() => setShowAddModal(true)} className="add-btn">Add new Mentor +</button>
      </div>

      <div className="d-flex justify-content-between">


        {/* Items per page selection */}
        <Form.Select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(Number(e.target.value))}
          className="pagination-select"
        >
          <option value="10">Show 10</option>
          <option value="20">Show 20</option>
          <option value="30">Show 30</option>
        </Form.Select>

        <div className="search-container">
          <Form.Control
            type="text"
            placeholder="Search Mentor"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <Button onClick={handleExportToExcel} className="excel-btn">
          <FaFileExcel className="excel-icon" /> Export to Excel
        </Button>

      </div>
      <Table striped bordered hover className="course-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Mentor Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Course</th>
            {/* <th>Image</th> */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCourses.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center text-danger">
                No details found
              </td>
            </tr>
          ) : (
            currentCourses.map((course, index) => (
              <tr
                key={course.id}
                className={course.status === "Active" ? "table-success" : "table-danger"}
              >
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{course.name}</td>
                <td>{course.email}</td>
                <td>{course.phone}</td>
                <td>{course.course}</td>
                {/* <td>
                  {course.image && (
                    <img
                      src={`http://localhost:8000/${course.image}`}
                      alt="mentor"
                      style={{ width: "60px", height: "60px", objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  )}
                </td> */}
                <td>
                  {course.status === "Active" && (
                    <>

                      <FaEdit
                        className="edit-icon"
                        onClick={() => {
                          setEditCourse(course);
                          setShowEditModal(true);
                        }}
                      />
                      <FaTrash
                        className="delete-icon"
                        onClick={() => handleDeleteCourse(course.id)}
                      /> &nbsp;
                      <FaDownload
                        className="download-icon"
                        onClick={() => handleDownloadpdf(course.pdf)} // pass mentor's PDF path
                      />
                    </>
                  )}
                  &nbsp;
                  <FaEye className="view-icon" onClick={() => handleViewDetail(course)} />
                </td>

              </tr>
            )))}
        </tbody>

      </Table>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <Button variant="secondary" onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))} disabled={currentPage === 1}>
          Previous
        </Button>
        <span className="page-number">Page {currentPage}</span>
        <Button
          variant="secondary"
          onClick={() => setCurrentPage((prev) => prev + 1)}
          disabled={indexOfLastItem >= filteredCourses.length}
        >
          Next
        </Button>
      </div>

      {/* Add Mentor Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Mentor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={newCourse}
            onChange={(e) => /^[a-zA-Z0-9./ ]*$/.test(e.target.value) && setNewCourse(e.target.value)}
            placeholder="Enter Mentor Name" required
          /><br />
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
            required
          />
          {email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) && (
            <div style={{ color: 'red', marginTop: '5px' }}>Invalid email format</div>
          )}
          <br />
          <Form.Control
            type="text"
            value={phone}
            onChange={(e) => {
              const input = e.target.value;
              if (/^\d{0,10}$/.test(input)) {
                setPhone(input);
              }
            }}
            placeholder="Enter Mobile Number"
            required
          />
          {phone.length !== 10 && phone.length > 0 && (

            <div style={{ color: 'red', marginTop: '5px' }}>
              Enter Valid Phone Number.
            </div>
          )}

          <br />
          <Form.Control
            type="text"
            value={coursename}
            onChange={(e) => /^[a-zA-Z0-9./ ]*$/.test(e.target.value) && setCoursename(e.target.value)}
            placeholder="Enter Course Name" required
          /><br />
          <Form.Control
            type="hidden"
            value={mentorid}
            readOnly
            placeholder="Mentor ID"
          /><br />
          <Form.Control
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />
          <Form.Text className="text-muted">
            Please upload a Image.
          </Form.Text><br /><br />

          <Form.Control
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdf(e.target.files[0])}
          />
          <Form.Text className="text-muted">
            Please upload a PDF file related to the mentor.
          </Form.Text>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
          <Button variant="success" onClick={handleAddCourse}>Add Mentor</Button>
        </Modal.Footer>
      </Modal>

      {/* View Mentor Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mentor Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs defaultActiveKey="general" id="student-details-tabs" className="mb-3">
            <Tab eventKey="general" title="General">
              {selectedMentor && (
                <div className="mentor-tab d-flex">
                  <div className="mentor-tab1">
                    {selectedMentor.image && (
                      <img
                        // src={`http://localhost:8000/uploads/${selectedMentor.image}`}
                        src={'https://crm.fazoacademy.in/php/uploads/${selectedMentor.image}'}
                        alt="mentor"
                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                      />
                    )}
                  </div>
                  <div className="mentor-tab2">
                    <p><strong>Name:</strong> {selectedMentor.name}</p>
                    <p><strong>Email:</strong> {selectedMentor.email}</p>
                    <p><strong>Phone:</strong> {selectedMentor.phone}</p>
                    <p><strong>Course:</strong> {selectedMentor.course}</p>
                  </div>
                </div>
              )}
            </Tab>

            <Tab eventKey="student_details" title="Student Details">
              {/* <Tabs defaultActiveKey="mentor_fees" id="mentor-fee-tabs" className="mb-3"> */}
              {studentList.some((s) => parseFloat(s.mentor_fees) > 0) && (
                // <Tab eventKey="mentor_fees" title="Mentor Fees 1">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Course</th>
                      <th>Mentor Fees</th>
                      <th>First Payment</th>
                      <th>Final Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentList.map((studentItem, index) => (
                      <tr key={index}>
                        <td>{studentItem.name}</td>
                        <td>{studentItem.coursedetails}</td>
                        <td>{studentItem.mentor_fees}</td>
                        <td>{studentItem.firstpayment}</td>
                        <td>{studentItem.finalpayment}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                // </Tab>
              )}

              {studentList.some((s) => parseFloat(s.mentorfees2) > 0) && (
                // <Tab eventKey="mentorfees2" title="Mentor Fees 2">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Course</th>
                      <th>Mentor Fees 2</th>
                      <th>First Payment</th>
                      <th>Final Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentList.map((studentItem, index) => (
                      <tr key={index}>
                        <td>{studentItem.name}</td>
                        <td>{studentItem.coursedetails}</td>
                        <td>{studentItem.mentorfees2}</td>
                        <td>{studentItem.firstpayment2}</td>
                        <td>{studentItem.finalpayment2}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                // </Tab>
              )}

              {!studentList.some((s) => parseFloat(s.mentor_fees) > 0 || parseFloat(s.mentorfees2) > 0) && (
                <p className="text-muted m-3">No students with mentor fees to display.</p>
              )}
              {/* </Tabs> */}
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>OK</Button>
        </Modal.Footer>
      </Modal>


      {/* Edit Mentor Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Mentor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={editCourse.name}
            onChange={(e) => setEditCourse({ ...editCourse, name: e.target.value })}
            placeholder="Enter Mentor Name"
          />
          <br />
          <Form.Control
            type="email"
            value={editCourse.email}
            onChange={(e) => setEditCourse({ ...editCourse, email: e.target.value })}
            placeholder="Enter Email"
          />
          <br />
          <Form.Control
            type="text"
            value={editCourse.phone}
            onChange={(e) => setEditCourse({ ...editCourse, phone: e.target.value })}
            placeholder="Enter Phone"
          />
          <br></br>
          <Form.Control
            type="text"
            value={editCourse.course}
            onChange={(e) => setEditCourse({ ...editCourse, course: e.target.value })}
            placeholder="Enter Course"
          />


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEditCourse}>
            Update Mentor
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default Mentor;
